import { jsx } from "react/jsx-runtime";
import { useState, createContext, useRef, useContext, useEffect } from "react";
import StructuredData from "../StructuredData/index.esm.js";
const FaqStructuredDataContext = createContext(null);
const FaqStructuredDataProvider = ({
  children
}) => {
  const [faqs, setFaqs] = useState([]);
  return /* @__PURE__ */ jsx(FaqStructuredDataContext.Provider, { value: {
    faqs,
    setFaqs
  }, children });
};
const useRegisterFaq = (faq) => {
  const setFaqs = useSetFaqs();
  const lastSetFaqRef = useRef(null);
  if (!lastSetFaqRef.current && faq && setFaqs) {
    lastSetFaqRef.current = faq;
    setFaqs((prevFaqs) => [...prevFaqs, faq]);
  }
  useRemoveFaqOnUnmount(lastSetFaqRef, setFaqs);
};
const useRemoveFaqOnUnmount = (lastSetFaqRef, setFaqs) => {
  useEffect(
    function setupFaqRemovalOnMount() {
      return function removeFaqOnUnmount() {
        if (!lastSetFaqRef.current || !setFaqs) {
          return;
        }
        setFaqs((prevFaqs) => {
          return prevFaqs.filter((aFaq) => aFaq !== lastSetFaqRef.current);
        });
      };
    },
    // lastSetFaqRef and setFaqs are stable. And this is a mount effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};
const useFaqs = () => {
  const context = useContext(FaqStructuredDataContext);
  return context == null ? void 0 : context.faqs;
};
const useSetFaqs = () => {
  const context = useContext(FaqStructuredDataContext);
  return context == null ? void 0 : context.setFaqs;
};
const FaqStructuredData = ({
  faq
}) => {
  useRegisterFaq(faq);
  return null;
};
const FaqStructuredDataScript = () => {
  const faqs = useFaqs();
  if (!faqs || faqs.length === 0) {
    return null;
  }
  const consolidatedData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.flatMap((faq) => faq.map((faqItem) => ({
      "@type": "Question",
      name: faqItem.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faqItem.answer
      }
    })))
  };
  return /* @__PURE__ */ jsx(StructuredData, { data: consolidatedData });
};
export {
  FaqStructuredData,
  FaqStructuredDataProvider,
  FaqStructuredDataScript
};
